import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Box,
  Grid,
  List,
  ListItem,
  TextField,
  Divider,
  Chip,
} from '@mui/material';
// import { Radio } from '@mui/joy';
import { ArrowBack, Done as DoneIcon } from '@mui/icons-material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { appApi } from 'src/apiUtils/AppApi';
import { url } from 'src/apiUtils/apiPath';
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
import { UserListHead } from '../sections/@dashboard/user';
import { validateUserDetail } from './studioPagehelpers';
// import { eventManager } from 'react-toastify/dist/core';
import config from '../AppConfig'

const TABLE_HEAD = [
  { id: 'display_user_name', label: `${config.appUserType} User Name`, alignHeader: false },
  { id: 'display_celebrity_name', label: `${config.appUserType} Name`, alignHeader: false },
  { id: 'phone_number', label: 'Phone Number', alignHeader: false },
  { id: 'actions', label: 'Actions', alignHeader: false },
];

export function SlotModification(expertId) {

  const [slotType, setSlotType] = useState(1)

  const [slotDateList, setSlotDateList] = useState([])

  const [slotTimeLIst, setSlotTimeLIst] = useState([])

  const [slotAvailableTimeLIst, setSlotAvailableTimeLIst] = useState([])

  const [selectedDateSlotList, setselectedDateSlotList] = useState([])

  const [dateSelected, setDateSelected] = useState(null)

  const [daySelected, setDaySelected] = useState(null)

  useEffect(() => {
    console.log(">>>>");
    appApi(url.SLOT_DATE_LIST, "GET", {}).then((result) => {
      if (result.status) {
        setSlotDateList(result.data)
        setDateSelected(result.data[0].date)
        setDaySelected(result.data[0].day)
      } else {
        setSlotDateList([])
      }
    })

    handleSelectDate(1);


  }, [])


  const handleAvailableSlot = (type, date = null, day = null) => {
    appApi(`${url.AVAILABLE_TIME_LIST}/${expertId.expertId}`, "GET", {}).then((result) => {
      if (result.status) {
        handleTimeListApi(type, date, day, result.data);
        setSlotAvailableTimeLIst(result.data)
        return result.data;
      } else {
        setSlotAvailableTimeLIst([])
        return []
      }
    })

  }

  const checkSlotAvailable = (data = {}, avlList = []) => {
    const timeZone = moment.tz.guess();
    let currentDate = moment().format('YYYY-MM-DD hh:mm A');
    const currentSelectedDate = moment(`${moment(data.selectedDate).format('YYYY-MM-DD')} ${data.startTime}`).format('YYYY-MM-DD hh:mm A')
    if (data.type === 2 && !moment(currentDate).isBefore(currentSelectedDate)) {
      return "expired"
    }
    if (data.type === 1 && moment(currentDate).day() === 6 || moment(currentDate).day() === 0) {
      currentDate = slotDateList.find((e) => e.day === 1)?.date;
    }
    const currentYmd = moment(currentDate).format('YYYY-MM-DD');
    if (avlList.length > 0) {
      const slotList = avlList?.find((e) => e?.date === moment(data.type === 1 ? currentYmd : data.selectedDate).format('YYYY-MM-DD'))?.slots;

      if (slotList && slotList.length > 0) {
        let slotTime = '';
        if (data.type === 1) {
          slotTime = slotList.find((e) => ((moment.utc(e.UTC_StartTime)?.tz(moment.tz.guess())?.local()?.format('hh:mm A') === moment(`${currentYmd} ${data.startTime}`).format('hh:mm A')) && e.slotType === 1))
        } else if (data.type === 2) {
          slotTime = slotList.find((e) => ((moment.utc(e.UTC_StartTime)?.tz(moment.tz.guess())?.local()?.format('hh:mm A') === moment(`${currentYmd} ${data.startTime}`).format('hh:mm A'))))
          console.log(slotTime)
        }
        if (slotTime?._id) {
          return 'already'
        }
      }
    }
    return '';
  }

  const handleTimeListApi = (type, date = null, day = null, avlList = []) => {
    appApi(url.SLOT_TIME_LIST, "POST", {}, JSON.stringify({
      userId: expertId.expertId, date: date ? moment(date).format('YYYY-MM-DD') : null, day
    })).then((result) => {
      if (result.status) {

        const resultData = result.data?.map((e) => {
          e.type = type;
          e.selectedDate = date;
          e.checkStatus = checkSlotAvailable(e, avlList);
          e.selectedDateSlotList = selectedDateSlotList
          return e;
        })
        setSlotTimeLIst(resultData)
      } else {
        setSlotTimeLIst([])
      }
    })
  }

  const handleSelectDate = (type, date = null, day = null) => {
    setDateSelected(date);
    setDaySelected(day)
    handleAvailableSlot(type, date, day);

  }

  const handleSelectedSlot = (slot, date) => {
    const selectedSlot = selectedDateSlotList;
    if (slotType === 1) {
      const indexToRemove = selectedSlot.findIndex((e) => e.date === 'all' && e.slotId === slot)
      if (indexToRemove !== -1) {
        selectedSlot.splice(indexToRemove, 1);
      } else {
        selectedSlot.push({ date: 'all', slotId: slot });
      }
    } else {
      const indexToRemove = selectedSlot.findIndex((e) => e.date === moment(date).format("YYYY-MM-DD") && e.slotId === slot)
      if (indexToRemove !== -1) {
        selectedSlot.splice(indexToRemove, 1);
      } else {
        selectedSlot.push({ date: moment(date).format("YYYY-MM-DD"), slotId: slot });
      }
    }
    console.log(selectedSlot);
    setselectedDateSlotList(selectedSlot)
    setSlotTimeLIst(slotTimeLIst.map((e) => {
      e.selectedDateSlotList = selectedSlot
      return e
    }));

  }
  const handleCustomCreate = () => {
    const timeZone = moment.tz.guess();
    const requestData = {}
    requestData.userId = expertId.expertId
    requestData.timeZone = timeZone
    requestData.availableTime = slotDateList.map((e) => {
      const obj = {}
      obj.availDate = moment(e.date).format('YYYY-MM-DD');
      obj.timing = selectedDateSlotList.filter((date) => date.date === obj.availDate)?.map((slot) => {
        const val = {}
        const slotData = slotTimeLIst.find((time) => time.slotTimeId === slot.slotId)
        val.slotTimingId = slot.slotId;
        val.startTime = slotData.startTime;
        val.endTime = slotData.endTime;
        return val
      })
      return obj
    })
    requestData.availableTime = requestData.availableTime.filter((e) => e.timing.length !== 0)
    if (requestData.availableTime.length === 0) {
      notify('No Slot is selected')
      return;
    }
    console.log("Req Data >>>>>>>>>>>>", requestData)
    console.log(JSON.stringify(requestData))
    appApi(url.AVAILABLE_SLOT_CUSTOM_CREATE, "POST", { "Content-Type": "application/json" }, JSON.stringify(requestData))
      .then((result) => {
        if (result.status) {
          setselectedDateSlotList([])
          setSlotTimeLIst(slotTimeLIst.map((e) => {
            e.selectedDateSlotList = []
            return e
          }));
          handleSelectDate(2, dateSelected, daySelected);
          notifySuccess('Slot Details Updated Successfully')
        }
      })
  }

  const handleWeeklyCreate = () => {
    const timeZone = moment.tz.guess();
    const requestData = {}
    requestData.userId = expertId.expertId
    requestData.timeZone = timeZone
    requestData.current_date = moment().format("YYYY-MM-DD")
    requestData.availDay = [1, 2, 3, 4, 5];
    requestData.availableTime = selectedDateSlotList.filter((date) => date.date === 'all')?.map((slot) => {
      const val = {}
      const slotData = slotTimeLIst.find((time) => time.slotTimeId === slot.slotId)
      val.slotTimingId = slot.slotId;
      val.startTime = slotData.startTime;
      val.endTime = slotData.endTime;
      return val
    })
    if (requestData.availableTime.length === 0) {
      notify('Slot is not selected')
      return;
    }
    console.log(requestData)
    appApi(url.AVAILABLE_SLOT_WEEKLY_CREATE, "POST", { "Content-Type": "application/json" }, JSON.stringify(requestData))
      .then((result) => {
        if (result.status) {
          setselectedDateSlotList([])
          setSlotTimeLIst(slotTimeLIst.map((e) => {
            e.selectedDateSlotList = []
            return e
          }));
          handleSelectDate(1)
          notifySuccess('Weekly Slot Updated')
        }
      })
  }

  const notify = (msg) => toast.error(
    msg,
    {
      pauseOnHover: false,
      autoClose: 2000,
      position: 'top-center'
    }
  );
  const notifySuccess = (msg) => toast.success(
    msg,
    {
      pauseOnHover: false,
      autoClose: 2000,
      position: 'top-center'
    }
  );

  return (
    <Box sx={{ padding: "2%" }}>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        width: '100%'

      }}>
        <Stack
          direction={'column'}
          justifyContent={'center'}
          alignContent={'center'}
          sx={{ width: '100%' }}
        >
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',

          }}>
            <TextField
              select
              name="slotType"
              value={slotType}
              onChange={(event) => {
                setSlotType(event.target.value)
                if (event.target.value === 1) {
                  handleSelectDate(event.target.value)
                } else {
                  handleSelectDate(event.target.value, slotDateList[0].date, slotDateList[0].day)
                }
              }}
              sx={{ width: '50%' }}
            >
              <MenuItem value={1}>{'Every Weekday (Monday to Friday)'}</MenuItem>
              <MenuItem value={2}>{'Custom'}</MenuItem>
            </TextField>
          </Box>
          {slotType === 2 ? <>
            <Box sx={{
              margin: 2,
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center'
            }}>
              <Stack direction={'row'}>
                {slotDateList.map((date) => (
                  //  onClick={setDateSelected(date.date)}
                  <Box
                    sx={{ padding: 2, borderBottom: moment(date.date).format('DD-MM-YYYY') === moment(dateSelected).format('DD-MM-YYYY') ? '2px solid #F5B501' : '' }}
                    onClick={() => {
                      handleSelectDate(slotType, date.date, date.day)
                    }}>
                    <Typography variant={'h6'} sx={{ color: moment(date.date).format('DD-MM-YYYY') === moment(dateSelected).format('DD-MM-YYYY') ? '#F5B501' : '' }}>
                      {moment(date.date).format('DD-MM-YYYY')}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Box>
          </> : <></>}

          <Box sx={{ width: '100%', padding: 3 }}>
            <Grid container spacing={3} >
              {slotTimeLIst.map((time) => (
                <Grid item xs={12} sm={6} md={4} lg={4} xl={4} >
                  <Box sx={{
                    padding: 2,
                    border: (time.checkStatus === 'already' || time.checkStatus === 'expired') ? '2px solid grey' : '2px solid #F5B501',
                    borderRadius: "10px",
                    margin: 2,
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center'
                  }}
                    onClick={() => {
                      if (time.checkStatus !== 'already') {
                        handleSelectedSlot(time.slotTimeId, dateSelected)
                      }
                    }}
                    key={time._id}
                  >
                    <Stack direction={'row'} key={time._id}>
                      {time.checkStatus !== 'already' && ((slotType === 1 ? time.selectedDateSlotList.findIndex((e) => e.date === 'all' && e.slotId === time.slotTimeId) : selectedDateSlotList.findIndex((e) => e.date === moment(dateSelected).format("YYYY-MM-DD") && e.slotId === time.slotTimeId)) !== -1) ? <DoneIcon sx={{
                        marginRight: 1
                      }} /> : <></>}

                      <Typography>
                        {time.checkStatus !== 'already' && ((slotType === 1 ? time.selectedDateSlotList.findIndex((e) => e.date === 'all' && e.slotId === time.slotTimeId) : time.selectedDateSlotList.findIndex((e) => e.date === moment(dateSelected).format("YYYY-MM-DD") && e.slotId === time.slotTimeId)) !== -1)}
                        {` ${time.startTime} - ${time.endTime} ${time.checkStatus === 'already' ? ' (Already Selected)' : (time.checkStatus === 'expired' ? ' (Slot Not Available) ' : '')}`}
                      </Typography>
                    </Stack>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Divider />
          <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            alignContent: 'center',
            width: '100%',
            marginTop: 3
          }}>
            <Button
              sx={{
                color: "white",
                paddingLeft: "10%",
                paddingRight: "10%",
                width: "15%",
                "&:hover": {
                  backgroundColor: "button.theme"
                },
                bgcolor: "button.theme",

              }}
              onClick={() => {
                if (slotType === 2) {
                  handleCustomCreate()
                } else {
                  handleWeeklyCreate()
                }
              }}
            >
              {'Submit'}
            </Button>
          </Box>
        </Stack>

      </Box >

    </Box >
  );

}



export default function StudioPage() {

  const [slotModify, setslotModify] = useState(false);

  const [isValidate, setIsValidate] = useState(false);

  const [isAllValid, setIsAllValid] = useState(false);

  const [page, setPage] = useState(0);

  const [isLoading, setIsloading] = useState(false)

  const [order, setOrder] = useState('asc');

  const [usersList, setUsersList] = useState([]);

  const [orderBy, setOrderBy] = useState('user.parnter_detail.user_name');

  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [userProfileDetail, setUserProfileDetail] = useState({
    "userPhone": "",
    "userName": "",
    "userId": "",
    "expertName": "",
    "description": "",
    "title": "",
    "avatarUrl": "",
    "file": "",
    "expertSkillLevel": "",
    "availableForSession": "",
    "language": [],
    "content_1_description": '',
    "content_1_media_id": '',
    "content_1_video": '',
    "content_1_thumbnail": '',
    "content_2_description": '',
    "content_2_media_id": '',
    "content_2_video": '',
    "content_2_thumbnail": '',
    "content_3_description": '',
    "content_3_media_id": '',
    "content_3_video": '',
    "content_3_thumbnail": '',
  })
  const [validationContent, setValidationContent] = useState({
    "userPhone": "",
    "userName": "",
    "userId": "",
    "expertName": "",
    "description": "",
    "title": "",
    "avatarUrl": "",
    "file": "",
    "expertSkillLevel": "",
    "availableForSession": "",
    "language": "",
    "content_1_description": '',
    "content_1_media_id": '',
    "content_1_video": '',
    "content_1_thumbnail": '',
    "content_2_description": '',
    "content_2_media_id": '',
    "content_2_video": '',
    "content_2_thumbnail": '',
    "content_3_description": '',
    "content_3_media_id": '',
    "content_3_video": '',
    "content_3_thumbnail": '',
  })

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    handleUserList(newPage, rowsPerPage)
  };

  const handleChangeRowsPerPage = async (event) => {
    console.log(event.target.value);
    setRowsPerPage(event.target.value);
    handleUserList(page, event.target.value)
  };


  const [addEdit, setaddEdit] = useState(false)
  const handleFormOpen = (id = null, action = '') => {
    setaddEdit(addEdit !== true);
    setslotModify(false)
    if (id !== '' && id !== null) {
      appApi(`${url.STUDIO_USER_INFO}/${id}`, "GET", {}).then((result) => {
        if (result.data.length > 0) {
          setUserProfileDetail((pre) => ({
            ...pre,
            userId: id,
            expertName: result.data[0].userName ?? '',
            description: result.data[0].description ?? '',
            title: result.data[0].title ?? '',
            expertSkillLevel: result.data[0]?.skillExperienceLevel?._id ?? '',
            availableForSession: result.data[0].availableForSession ?? '',
            userPhone: result.data[0]?.users[0]?.userPhone,
            userName: result.data[0]?.userDetail[0]?.userName,
            language: Object.values(result.data[0].expertLanguage.map((e) => {
              return e?.languages?._id
            })),
            content_1_description: result.data[0]?.promotionContent[0]?.mediaDesc ?? '',
            content_1_video: '',
            content_1_thumbnail: '',
            content_1_media_id: result.data[0]?.promotionContent[0]?._id ?? '',
            content_2_description: result.data[0]?.promotionContent[1]?.mediaDesc ?? '',
            content_2_video: '',
            content_2_thumbnail: '',
            content_2_media_id: result.data[0]?.promotionContent[1]?._id ?? '',
            content_3_description: result.data[0]?.promotionContent[2]?.mediaDesc ?? '',
            content_3_video: '',
            content_3_thumbnail: '',
            content_3_media_id: result.data[0]?.promotionContent[2]?._id ?? '',
            avatarUrl: result.data[0]?.avatarUrl ?? ''
          }))
          setpromotionContentList(result.data[0]?.promotionContent)
        } else {
          setUserProfileDetail((pre) => ({
            ...pre,
            userPhone: '',
            userName: '',
            userId: id,
            expertName: '',
            description: '',
            title: '',
            expertSkillLevel: '',
            availableForSession: '',
            language: [],
            content_1_description: '',
            content_1_media_id: '',
            content_1_video: '',
            content_1_thumbnail: '',
            content_2_description: '',
            content_2_media_id: '',
            content_2_video: '',
            content_2_thumbnail: '',
            content_3_description: '',
            content_3_media_id: '',
            content_3_video: '',
            content_3_thumbnail: '',
            avatarUrl: ''
          }))
          setpromotionContentList([])
        }

      })
    } else {
      setUserProfileDetail((pre) => ({
        ...pre,
        userPhone: '',
        userName: '',
        userId: id,
        expertName: '',
        description: '',
        title: '',
        expertSkillLevel: '',
        availableForSession: '',
        language: [],
        content_1_media_id: '',
        content_1_description: '',
        content_1_video: '',
        content_1_thumbnail: '',
        content_2_media_id: '',
        content_2_description: '',
        content_2_video: '',
        content_2_thumbnail: '',
        content_3_media_id: '',
        content_3_description: '',
        content_3_video: '',
        content_3_thumbnail: '',
        avatarUrl: ''
      }))
      setpromotionContentList([])
    }
  };
  const [languageList, setlanguageList] = useState([])

  const [sessionList, setsessionList] = useState([])

  const [expertLevelList, setexpertLevelList] = useState([])

  const [promotionContentList, setpromotionContentList] = useState([])

  const [userType, setUserType] = useState(1)

  const [submitDisabled, setSubmitDisabled] = useState(false);

  useEffect(() => {
    appApi(url.LANGUAGE_LIST, "GET", {}).then((result) => {
      if (result.data.Languages.length > 0) {
        setlanguageList(result.data.Languages)
        setsessionList(result.data.availableForSession)
      } else {
        setlanguageList([])
        setsessionList([])
      }
    })
    appApi(url.EXPERT_LEVEL_LIST, "GET", {}).then((result) => {
      if (result.data.length > 0) {
        setexpertLevelList(result.data)
      } else {
        setexpertLevelList([])
      }
    })
    handleUserList(0, 5)

  }, [])

  useEffect(() => {
    setValidationContent((pre) => ({
      userPhone: validateUserDetail(userProfileDetail.userPhone, 'userPhone', userProfileDetail),
      userName: validateUserDetail(userProfileDetail.userName, 'userName', userProfileDetail),
      expertName: validateUserDetail(userProfileDetail.expertName, 'expertName', userProfileDetail),
      description: validateUserDetail(userProfileDetail.description, 'description', userProfileDetail),
      title: validateUserDetail(userProfileDetail.title, 'title', userProfileDetail),
      expertSkillLevel: validateUserDetail(userProfileDetail.expertSkillLevel, 'expertSkillLevel', userProfileDetail),
      availableForSession: validateUserDetail(userProfileDetail.availableForSession, 'availableForSession', userProfileDetail),
      language: validateUserDetail(userProfileDetail.language, 'language', userProfileDetail),
      file: validateUserDetail(userProfileDetail.file, 'file', userProfileDetail, userProfileDetail.avatarUrl === ''),

      content_1_description: validateUserDetail(userProfileDetail.content_1_description, 'content_1_description', userProfileDetail),
      content_1_media_id: validateUserDetail(userProfileDetail.content_1_media_id, 'content_1_media_id', userProfileDetail, false),
      content_1_video: validateUserDetail(userProfileDetail.content_1_video, 'content_1_video', userProfileDetail, (!userProfileDetail.content_1_media_id || userProfileDetail.content_1_video !== '')),
      content_1_thumbnail: validateUserDetail(userProfileDetail.content_1_thumbnail, 'content_1_thumbnail', userProfileDetail, (!userProfileDetail.content_1_media_id || userProfileDetail.content_1_video !== '')),

      content_2_media_id: validateUserDetail(userProfileDetail.content_2_media_id, 'content_2_media_id', userProfileDetail, false),
      content_2_description: validateUserDetail(userProfileDetail.content_2_description, 'content_2_description', userProfileDetail, (userProfileDetail.content_2_media_id || userProfileDetail.content_2_video !== '')),
      content_2_video: validateUserDetail(userProfileDetail.content_2_video, 'content_2_video', userProfileDetail, false),
      content_2_thumbnail: validateUserDetail(userProfileDetail.content_2_thumbnail, 'content_2_thumbnail', userProfileDetail, (userProfileDetail.content_2_video !== '')),

      content_3_description: validateUserDetail(userProfileDetail.content_3_description, 'content_3_description', userProfileDetail, (userProfileDetail.content_3_media_id || userProfileDetail.content_3_video !== '')),
      content_3_media_id: validateUserDetail(userProfileDetail.content_3_media_id, 'content_3_media_id', false),
      content_3_video: validateUserDetail(userProfileDetail.content_3_video, 'content_3_video', userProfileDetail, false),
      content_3_thumbnail: validateUserDetail(userProfileDetail.content_3_thumbnail, 'content_3_thumbnail', userProfileDetail, (userProfileDetail.content_3_video !== '')),

    }))
  }, [userProfileDetail])

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };


  const handleCreateUser = () => {
    let allValid = false;
    const data = {
      ...userProfileDetail
    }
    setIsValidate(true)
    setIsAllValid(false)
    const validationKey = Object.keys(validationContent);
    console.log(validationContent);
    validationKey.forEach((e) => {
      if (validationContent[e]?.length > 0) {
        setIsAllValid(true)
        allValid = true;
      }
    })
    if (allValid) {
      return;
    }
    const formData = new FormData();
    const keys = Object.keys(data);
    keys.forEach((e) => {
      if (e === "language") {
        data[e].forEach((ln, i) => {
          formData.append(`${e}[]`, data[e] ? data[e][i] : '')
        })
      }
      else {
        formData.append(e, data[e])
      }
    })
    setSubmitDisabled(true)
    appApi(url.STUDIO_USER_CREATE, "POST", {}, formData)
      .then((result) => {
        if (result && result.status === true) {
          notifySuccess(result.msg)
          handleUserList(0, 5)
          handleFormOpen()
          setIsValidate(false)
          setSubmitDisabled(false)
        }
        else {
          notify(result.msg)
          setSubmitDisabled(false)
        }
      })
  }
  const notify = (msg) => toast.error(
    msg,
    {
      pauseOnHover: false,
      autoClose: 2000,
      position: 'top-center'
    }
  );
  const notifySuccess = (msg) => toast.success(
    msg,
    {
      pauseOnHover: false,
      autoClose: 2000,
      position: 'top-center'
    }
  );
  const [userListCount, setUserListCount] = useState(0);
  const handleUserList = (pages, rows) => {
    // setUserType(event.target.value)
    setPage(pages);
    setRowsPerPage(rows)
    appApi(`${url.STUDIO_USER_LIST}/${userType}?limit=${rows}&page=${pages + 1}`, "GET", { params: { page, limit: rowsPerPage } }).then((result) => {
      if (result.data.expertDtlProf.length > 0) {
        setUsersList(result.data.expertDtlProf)
        setUserListCount(result.data?.count[0]?.count)
      } else {
        setUsersList([])
        setUserListCount(0)
      }

    })
  }
  const [expertId, setExpertId] = useState(null)
  const handleSlotOpen = (id) => {
    setslotModify(!slotModify)
    setaddEdit(!slotModify);
    setExpertId(id)

  }

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userListCount) : 0;

  return (
    <>
      <Helmet>
        <title> {config.appUserType} Management  </title>
      </Helmet>

      < Container maxWidth="xl">
        <Card sx={{ padding: 2, marginBottom: 3 }}>
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box sx={{ paddingTop: 1 }}>
              <Typography variant="h4" gutterBottom>
                {config.appUserType} Management
              </Typography>
            </Box>
            {addEdit ?
              <Button variant="contained" startIcon={addEdit ? <ArrowBack /> : <Iconify icon="eva:plus-fill" />} sx={{
                backgroundColor: "action.selected", '&:hover': {
                  backgroundColor: "action.selected",
                }
              }}
                onClick={() => {
                  handleFormOpen()
                }} >
                {"Back"}
              </Button> : <>
                <Button variant="contained" startIcon={addEdit ? <ArrowBack /> : <Iconify icon="eva:plus-fill" />} sx={{
                  backgroundColor: "action.selected", '&:hover': {
                    backgroundColor: "action.selected",
                  }
                }}
                  onClick={() => {
                    handleFormOpen()
                  }} >
                  {`Add ${config.appUserType}`}
                </Button>
              </>}
          </Stack>
        </Card>
        <Card>
          {addEdit ?
            <>  {slotModify ? <SlotModification expertId={expertId} /> :
              <Box>
                <Box sx={{ padding: 5 }}>
                  <List>
                    <ListItem>
                      <TextField
                        fullWidth
                        error={isValidate && Array.isArray(validationContent?.userName) ? validationContent?.userName[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.userName) ? validationContent?.userName[0]?.msg : ''}
                        label={"Enter User Name"}
                        name="user_name"
                        placeholder='Enter your name'
                        value={userProfileDetail.userName}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            userName: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      />
                      <TextField
                        fullWidth
                        error={isValidate && Array.isArray(validationContent?.expertName) ? validationContent?.expertName[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.expertName) ? validationContent?.expertName[0]?.msg : ''}
                        label={`Enter ${config.appUserType} Name`}
                        name="user_name"
                        placeholder='Enter your name'
                        value={userProfileDetail.expertName}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            expertName: event.target.value
                          }))
                        }}
                        sx={{ marginLeft: 1 }}
                      />
                    </ListItem>
                    <ListItem>
                      <TextField
                        fullWidth
                        error={isValidate && Array.isArray(validationContent?.userPhone) ? validationContent?.userPhone[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.userPhone) ? validationContent?.userPhone[0]?.msg : ''}
                        label={"Phone Number"}
                        name="userPhone"
                        value={userProfileDetail.userPhone}
                        inputProps={{
                          maxLength: 10,
                        }}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            userPhone: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      />
                      <TextField
                        fullWidth
                        error={isValidate && Array.isArray(validationContent?.title) ? validationContent?.title[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.title) ? validationContent?.title[0]?.msg : ''}
                        label={"Sub Title / Caption"}
                        name="sub_title"
                        value={userProfileDetail.title}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            title: event.target.value
                          }))
                        }}
                        sx={{ marginLeft: 1 }}
                      />
                    </ListItem>
                    <ListItem>
                      <TextField
                        select
                        fullWidth
                        error={isValidate && Array.isArray(validationContent?.expertSkillLevel) ? validationContent?.expertSkillLevel[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.expertSkillLevel) ? validationContent?.expertSkillLevel[0]?.msg : ''}
                        label={"Skill Experience Level"}
                        name="skillExperienceLevel"
                        value={userProfileDetail.expertSkillLevel}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            expertSkillLevel: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      >
                        <MenuItem key={''} value={''}>{expertLevelList?.length > 0 ? 'Choose your Genre' : 'None'}</MenuItem>

                        {expertLevelList?.length > 0 ? expertLevelList.map((e) => (
                          <MenuItem key={e._id} value={e._id}>{e.level}</MenuItem>
                        )) : <></>
                        }
                      </TextField>
                      <TextField
                        id="user_language"
                        select
                        fullWidth
                        error={isValidate && Array.isArray(validationContent?.language) ? validationContent?.language[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.language) ? validationContent?.language[0]?.msg : ''}
                        label="Choose Your Language"
                        SelectProps={{
                          multiple: true,
                          value: userProfileDetail.language,
                          onChange: (event) => {
                            setUserProfileDetail((pre) => ({
                              ...pre,
                              language: event.target.value
                            }))
                          },
                          renderValue: (selected) => (
                            <div>
                              {selected.map((value) => (<Chip key={value}
                                label={languageList.find((lang) => lang._id === value)?.language}
                              />
                              ))}
                            </div>
                          ),
                        }}
                        sx={{ marginLeft: 1 }
                        }
                      >
                        {languageList?.length > 0 ? languageList.map((e) => (
                          <MenuItem key={e._id} value={e._id}>{e.language}</MenuItem>
                        )) : <><MenuItem key={''} value={''}>{'None'}</MenuItem></>
                        }
                      </TextField>
                    </ListItem>


                    <ListItem sx={{ marginTop: 2 }}>
                      <TextField
                        error={isValidate && Array.isArray(validationContent?.availableForSession) ? validationContent?.availableForSession[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.availableForSession) ? validationContent?.availableForSession[0]?.msg : ''}
                        select
                        fullWidth
                        label={"Available for session?"}
                        name="user_session"
                        value={userProfileDetail.availableForSession}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            availableForSession: event.target.value
                          }))
                        }}
                        sx={{ marginRight: 1 }}
                      >
                        <MenuItem key={''} value={''}>{sessionList?.length > 0 ? 'Choose your availability' : 'None'}</MenuItem>

                        {sessionList?.length > 0 ? sessionList.map((e) => (
                          <MenuItem key={e} value={e}>{e}</MenuItem>
                        )) : <></>
                        }
                      </TextField>
                      <Box sx={{ width: '100%' }}>
                        <Stack direction="column" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignContent: 'flex-end' }}>
                            {
                              promotionContentList && promotionContentList[0] && promotionContentList[0]?.mediaPath
                                ? <a href={promotionContentList[0]?.mediaPath} target="_blank" rel="noreferrer">View</a> :
                                <></>
                            }
                          </Box>


                          <TextField
                            error={isValidate && Array.isArray(validationContent?.file) ? validationContent?.file[0]?.valid : false}
                            helperText={isValidate && Array.isArray(validationContent?.file) ? validationContent?.file[0]?.msg : ''}
                            fullWidth
                            label="Upload Profile Picture"
                            InputLabelProps={{
                              shrink: true,
                              position: "top"
                            }}
                            InputProps={{
                              type: "file"
                            }}

                            onChange={(event) => {
                              if (event.target.files[0].type.startsWith('image/')) {
                                setUserProfileDetail((pre) => ({
                                  ...pre,
                                  file: event.target.files[0]
                                }))
                              } else {
                                event.target.value = '';
                                setUserProfileDetail((pre) => ({
                                  ...pre,
                                  file: '',
                                }))
                              }
                            }}
                            sx={{ marginLeft: 1 }}
                          />
                        </Stack>
                      </Box>
                    </ListItem>
                    <ListItem>
                      <Card sx={{ padding: 2, boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px" }}>
                        <Stack direction="row" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography sx={{ color: 'button.Primary' }}>Promotion Content 1</Typography>
                          {
                            promotionContentList && promotionContentList[0] && promotionContentList[0]?.mediaPath
                              ? <a href={promotionContentList[0]?.mediaPath} target="_blank" rel="noreferrer">View</a> :
                              <></>
                          }
                        </Stack>
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_1_video) ? validationContent?.content_1_video[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_1_video) ? validationContent?.content_1_video[0]?.msg : ''}
                          label="Upload Video"
                          InputLabelProps={{
                            shrink: true,
                            position: "top"
                          }}
                          InputProps={{
                            type: "file"
                          }}
                          accept={''}
                          onChange={(event) => {
                            if (event.target.files[0].type.startsWith('video/')) {
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_1_video: event.target.files[0],
                              }))
                            } else {
                              event.target.value = '';
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_1_video: '',
                              }))
                            }
                          }}
                          sx={{ marginTop: 2 }}
                        />
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_1_thumbnail) ? validationContent?.content_1_thumbnail[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_1_thumbnail) ? validationContent?.content_1_thumbnail[0]?.msg : ''}
                          label="Upload Picture"
                          InputLabelProps={{
                            shrink: true,
                            position: "top"
                          }}
                          InputProps={{
                            type: "file"
                          }}
                          accept={''}
                          onChange={(event) => {
                            if (event.target.files[0].type.startsWith('image/')) {
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_1_thumbnail: event.target.files[0],
                              }))
                            } else {
                              event.target.value = '';
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_1_thumbnail: '',
                              }))
                            }
                          }}
                          sx={{ marginTop: 2 }}
                        />
                        <TextField
                          fullWidth
                          multiline
                          error={isValidate && Array.isArray(validationContent?.content_1_description) ? validationContent?.content_1_description[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_1_description) ? validationContent?.content_1_description[0]?.msg : ''}
                          label={"Description"}
                          name="description"
                          rows={4}

                          placeholder='Enter Some details'
                          value={userProfileDetail.content_1_description}
                          onChange={(event) => {
                            setUserProfileDetail((pre) => ({
                              ...pre,
                              content_1_description: event.target.value
                            }))
                          }}
                          sx={{ marginTop: 2 }}
                        />
                      </Card>
                      <Card sx={{ padding: 2, marginLeft: 2, boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px" }}>
                        <Stack direction="row" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography sx={{ color: 'button.Primary' }}>Promotion Content 2</Typography>
                          {
                            promotionContentList && promotionContentList[1] && promotionContentList[1]?.mediaPath
                              ? <a href={promotionContentList[1]?.mediaPath} target="_blank" rel="noreferrer">View</a> :
                              <></>
                          }
                        </Stack>
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_2_video) ? validationContent?.content_2_video[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_2_video) ? validationContent?.content_2_video[0]?.msg : ''}
                          label="Upload Video"
                          InputLabelProps={{
                            shrink: true,
                            position: "top"
                          }}
                          InputProps={{
                            type: "file"
                          }}

                          onChange={(event) => {
                            if (event.target.files[0].type.startsWith('video/')) {
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_2_video: event.target.files[0]
                              }))
                            } else {
                              event.target.value = '';
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_2_video: '',
                              }))
                            }
                          }}
                          sx={{ marginTop: 2 }}
                        />
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_2_thumbnail) ? validationContent?.content_2_thumbnail[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_2_thumbnail) ? validationContent?.content_2_thumbnail[0]?.msg : ''}
                          label="Upload Picture"
                          InputLabelProps={{
                            shrink: true,
                            position: "top"
                          }}
                          InputProps={{
                            type: "file"
                          }}
                          accept={''}
                          onChange={(event) => {
                            if (event.target.files[0].type.startsWith('image/')) {
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_2_thumbnail: event.target.files[0],
                              }))

                            } else {
                              event.target.value = '';
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_2_thumbnail: '',
                              }))
                            }
                          }}
                          sx={{ marginTop: 2 }}
                        />
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_2_description) ? validationContent?.content_2_description[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_2_description) ? validationContent?.content_2_description[0]?.msg : ''}
                          multiline
                          label={"Description"}
                          name="description"
                          rows={4}

                          placeholder='Enter Some details'
                          value={userProfileDetail.content_2_description}
                          onChange={(event) => {
                            setUserProfileDetail((pre) => ({
                              ...pre,
                              content_2_description: event.target.value
                            }))
                          }}
                          sx={{ marginTop: 2 }}
                        />
                      </Card>
                      <Card sx={{ padding: 2, marginLeft: 2, boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px" }}>
                        <Stack direction="row" sx={{ display: 'flex', justifyContent: 'space-between' }}>
                          <Typography sx={{ color: 'button.Primary' }}>Promotion Content 3</Typography>
                          {
                            promotionContentList && promotionContentList[2] && promotionContentList[2]?.mediaPath
                              ? <a href={promotionContentList[2]?.mediaPath} target="_blank" rel="noreferrer">View</a> :
                              <></>
                          }
                        </Stack>
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_3_video) ? validationContent?.content_3_video[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_3_video) ? validationContent?.content_3_video[0]?.msg : ''}
                          label="Upload Video"
                          InputLabelProps={{
                            shrink: true,
                            position: "top"
                          }}
                          InputProps={{
                            type: "file"
                          }}

                          onChange={(event) => {
                            if (event.target.files[0].type.startsWith('video/')) {
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_3_video: event.target.files[0]
                              }))
                            } else {
                              event.target.value = '';
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_3_video: '',
                              }))
                            }
                          }}
                          sx={{ marginTop: 2 }}
                        />
                        <TextField
                          fullWidth
                          error={isValidate && Array.isArray(validationContent?.content_3_thumbnail) ? validationContent?.content_3_thumbnail[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_3_thumbnail) ? validationContent?.content_3_thumbnail[0]?.msg : ''}
                          label="Upload Picture"
                          InputLabelProps={{
                            shrink: true,
                            position: "top"
                          }}
                          InputProps={{
                            type: "file"
                          }}
                          onChange={(event) => {
                            if (event.target.files[0].type.startsWith('image/')) {
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_3_thumbnail: event.target.files[0],
                              }))
                            } else {
                              event.target.value = '';
                              setUserProfileDetail((pre) => ({
                                ...pre,
                                content_3_thumbnail: '',
                              }))
                            }
                          }}
                          sx={{ marginTop: 2 }}
                        />
                        <TextField
                          fullWidth
                          multiline
                          error={isValidate && Array.isArray(validationContent?.content_3_description) ? validationContent?.content_3_description[0]?.valid : false}
                          helperText={isValidate && Array.isArray(validationContent?.content_3_description) ? validationContent?.content_3_description[0]?.msg : ''}
                          label={"Description"}
                          name="description"
                          rows={4}

                          placeholder='Enter Some details'
                          value={userProfileDetail.content_3_description}
                          onChange={(event) => {
                            setUserProfileDetail((pre) => ({
                              ...pre,
                              content_3_description: event.target.value
                            }))
                          }}
                          sx={{ marginTop: 2 }}
                        />
                      </Card>
                    </ListItem>
                    <ListItem>
                      <TextField
                        fullWidth
                        multiline
                        label={"Introduction"}
                        name="introduction"
                        rows={4}
                        error={isValidate && Array.isArray(validationContent?.description) ? validationContent?.description[0]?.valid : false}
                        helperText={isValidate && Array.isArray(validationContent?.description) ? validationContent?.description[0]?.msg : ''}
                        placeholder='Enter Some details'
                        value={userProfileDetail.description}
                        onChange={(event) => {
                          setUserProfileDetail((pre) => ({
                            ...pre,
                            description: event.target.value
                          }))
                        }}
                        sx={{ marginTop: 2 }}
                      />
                    </ListItem>

                    <ListItem
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginTop: 2
                      }}
                    >
                      <Button
                        sx={{
                          color: "white",
                          paddingLeft: "10%",
                          paddingRight: "10%",
                          width: "10%",
                          height: "20%",
                          "&:hover": {
                            backgroundColor: "button.theme"
                          },
                          bgcolor: "button.theme",

                        }}
                        disabled={submitDisabled}
                        onClick={() => {
                          handleCreateUser()
                        }}>
                        {'Submit'}
                      </Button>
                    </ListItem>
                  </List>


                </Box>
              </Box>}</> : <>
              <Box sx={{ padding: 1 }}>
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      <UserListHead
                        order={order}
                        orderBy={orderBy}
                        headLabel={TABLE_HEAD}
                        rowCount={userListCount}
                        onRequestSort={handleRequestSort}
                      />
                      <TableBody>
                        {/* .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) */}
                        {usersList.map((user) => (
                          <TableRow key={user._id}>
                            <TableCell align="left">{user?.userName ?? '--'}</TableCell>
                            <TableCell align="left">{user?.expertName ?? '--'}</TableCell>
                            <TableCell align="left">{user?.userPhone ?? '--'}</TableCell>


                            <TableCell align="left">
                              <Stack direction={'row'} sx={{ padding: 1 }}>
                                <Button variant="contained" startIcon={<Iconify icon={'eva:edit-fill'} />} sx={{
                                  backgroundColor: "action.selected", '&:hover': {
                                    backgroundColor: "action.selected",
                                  }
                                }}
                                  onClick={() => {
                                    handleFormOpen(user._id, 'edit')
                                  }} >
                                  {"Edit"}
                                </Button>
                                <Button variant="contained"
                                  sx={{
                                    backgroundColor: "#F5B501", '&:hover': {
                                      backgroundColor: "#F5B501"
                                    },
                                    marginLeft: 1
                                  }}
                                  onClick={() => {
                                    handleSlotOpen(user._id)
                                  }} >
                                  {"Modify Slot"}
                                </Button>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )}
                      </TableBody>
                      {usersList && usersList.length === 0 && (
                        <TableBody>
                          <TableRow>
                            <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                              <Paper
                                sx={{
                                  textAlign: 'center',
                                }}
                              >
                                <Typography variant="h6" paragraph color={'red'}>
                                  {isLoading ? 'Loading .....' : 'No Data Found'}
                                </Typography>
                              </Paper>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      )}

                    </Table>
                  </TableContainer>
                </Scrollbar>

                {userListCount > rowsPerPage ?
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={userListCount}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  /> : <></>}
              </Box>
            </>}

        </Card>
        {/* <RelatedSkilModal /> */}
      </Container >
      <ToastContainer />

    </>
  );
}